import { UpdateViewType, hub, UpdateViewField } from "../hub";
import { TVContext } from "../hub/context";
import { ViewPortSync } from "./viewport"
import { CrossHairSync } from "./crosshair"
import { DrawingSync } from "./drawing"
import { BarReplaySync } from "./barreplay";
import { FixDataSync } from "./fixdata";
import { DayKSync } from "./dayk";
import { SyncerChange, TVSyncerTool } from "./syncitem";
import { TradingSync } from './trading';

class GroupSync {
    barReplay: BarReplaySync;
    fixData: FixDataSync;
    crossHair: CrossHairSync;
    drawings: DrawingSync;
    viewPort: ViewPortSync;
    trading: TradingSync;
    dayk: DayKSync;
    tools: TVSyncerTool[] = [];
    constructor(syncer: TVSyncer, tvd: TVContext) {
        if (hub.admin) {
            //this.barReplay = this.push(new BarReplaySync(syncer, tvd));
            //this.fixData = this.push(new FixDataSync(syncer, tvd));
            //this.dayk = this.push(new DayKSync(syncer, tvd));
        }
        this.crossHair = this.push(new CrossHairSync(syncer, tvd));
        this.drawings = this.push(new DrawingSync(syncer, tvd));
        this.viewPort = this.push(new ViewPortSync(syncer, tvd));
        this.trading = this.push(new TradingSync(syncer, tvd));
    }
    push<TTool extends TVSyncerTool>(tool: TTool) {
        this.tools.push(tool);
        return tool;
    }
    beforeChange(type: SyncerChange) {
        this.tools.forEach(x => x.onBeforeChange(type));
    }
    endChange(type: SyncerChange) {
        this.tools.forEach(x => x.onEndChange(type));
    }
    onInit() {
        this.tools.forEach(x => x.onInit());
    }

    updateView(init: boolean, type: UpdateViewType, field: UpdateViewField) {
        if (type & UpdateViewType.TV) {
            this.crossHair?.updateView(init);
            this.drawings?.updateView(init);
        }
        if (type & UpdateViewType.General) {
            this.trading?.updateView(field == UpdateViewField.Some);
        }
    }
    clear() {
        this.tools.forEach(x => x.clear());
    }
    dispose() {
        this.tools.forEach(x => x.dispose());
    }
}
export enum SyncerUpdateType {
    Init,
    Data,
    Symbol
}
export class TVSyncer {
    items = new Array<GroupSync>();
    private updates = 0;
    private inited = false;
    private lockId = -1;

    add(tvd: TVContext) {
        this.items.push(new GroupSync(this, tvd));
    }

    updateView(tvd: TVContext, init: boolean, type: UpdateViewType, field: UpdateViewField = UpdateViewField.Some) {
        this.items[tvd.id].updateView(init, type, field);
    }
    beforeChange(tvd: TVContext, type: SyncerUpdateType) {
        if (type != SyncerUpdateType.Init)
            this.items[tvd.id].beforeChange(type as number as SyncerChange);
    }
    endChange(tvd: TVContext, type: SyncerUpdateType) {
        if (type == SyncerUpdateType.Init)
            this.items[tvd.id].onInit();
        else
            this.items[tvd.id].endChange(type as number as SyncerChange);
    }
    isInited() {
        return this.updates == 0 && this.inited;
    }
    isReleased(tv: TVContext) {
        return tv.id == this.lockId || this.lockId == -1;
    }
    lock(tv: TVContext) {
        if (this.lockId == -1) {
            this.lockId = tv.id;
            return true;
        }
        return this.lockId == tv.id;

    }
    release(tv: TVContext) {
        if (tv.id == this.lockId)
            this.lockId = -1;

    }

    beginLocalUpdate() {
        this.updates++;
    }
    endLocalUpdate() {
        this.updates--;
    }
    beginUpdate() {
        if (this.updates++ == 0)
            this.items.forEach(x => x.clear());
        this.inited = false;
    }
    endUpdate() {
        this.updates--;
    }
    onInited() {
        this.inited = true;
    }

    dispose() {
        this.items.forEach(x => x.dispose());
        this.items = [];
    }
}
